<template>
    <div class="data-picker-container">
        <v-menu
            lazy
            offset-y
            full-width
            ref="menu"
            transition="scale-transition"
            min-width="290px"
            :close-on-content-click="false"
            :return-value.sync="date"
            :nudge-right="40"
			:style="`color:${$appColors.info}`"
            v-model="menu"
        >
        <template slot="activator" slot-scope="{ on }">
			<label :style="`color:${$appColors.info}`">{{label}}</label>
			<input
				readonly
				prepend-icon="event"
				class="new-diagnosis-input"
				v-model="date"
				v-on="on"
			>
        </template>
        <v-date-picker
			no-title
			scrollable
			class="menu-date-picker"
			:allowed-dates="allowedDates"
			:value="date"
			@input="setDate"
		>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="menu = false">Cancelar</v-btn>
          <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
        </v-date-picker>
      </v-menu>
    </div>
</template>
<script>

function setDate(date) {
	this.date = date;
	this.$emit('input', date);
}

function data() {
	return {
		date: '',
		menu: false,
	};
}

export default {
	name: 'app-date',
	inheritAttrs: false,
	data,
	methods: {
		setDate,
	},
	props: {
		allowedDates: {
			type: Function,
		},
		label: {
			type: String,
		},
	},
};
</script>
<style lang="scss" scoped>
.data-picker-container {
	label {
		font-size: size(small);
	}
}
</style>


// WEBPACK FOOTER //
// src/components/shared/app-date.vue